<br />
<div  *ngIf="toggle">
  <div class="form-row">
    <div class="form-group col-md-24">
      <h1 for="inventors">Yeni Buluş Sahibi Kaydet</h1>
      <br />
      <p></p>
      <div *ngIf="!invComp">
        <h2>Kaydedilecek Buluş Sahibinin Çalıştığı Başvuru Sahibi Seçin</h2>
        <br />
        <div class="form-row" id="inventors">
          <div *ngFor="let user of companies; let i = index">
            <div *ngFor="let item of user; index as idx">
              <button
                type="button"
                (click)="inventorsCompany(item.CompanyName, item.CompanyAdress)"
              >
                {{ item.CompanyName }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <h2 *ngIf="invComp">
        {{ inventorCompany.name }} bünyesinde çalışan Buluş Sahibinin
        Bilgilerini Girin
      </h2>
      <p></p>
      <div class="form-group col-md-6" id="inventors" *ngIf="invComp">
        <div class="form-group col-md-2" >
          <div >
            <input [(ngModel)]="inventorName" placeholder="Buluşçu Ad/Soyad" (ngModelChange)="inventorName = $event.toLowerCase()"/>

          </div>
        </div>

        <div class="form-group col-md-2" >
          <div >
            <input [(ngModel)]="inventorAdress" placeholder="Buluşçu Adres" (ngModelChange)="inventorAdress = $event.toLowerCase()"/>

          </div>
        </div>

        <div class="form-group col-md-2" >
          <div >
            <input [(ngModel)]="inventorMail" placeholder="Buluşçu e-posta"  (ngModelChange)="inventorMail = $event.toLowerCase()"/>

          </div>
        </div>
        <div class="form-group col-md-2">
          <div >
            <input [(ngModel)]="inventorIdentityNo" placeholder="Buluşçu Kimlik No."  (ngModelChange)="inventorIdentityNo = $event.toLowerCase()"/>

          </div>
        </div>

        <div class="form-group col-md-2">
          <div>
            <input [(ngModel)]="inventorStatus" placeholder="Buluşçu Pozisyon" (ngModelChange)="inventorStatus = $event.toLowerCase()"/>

          </div>

          <p>{{ error }}</p>
        </div>
        <div id="inventors">
          <div>
            <button
              (click)="submit()"
              class="btn"

              style="
                margin-left: auto;
                margin-right: 20%;
                font-size: 18px;
                display: block;
              "
            >
              Buluş Sahibini Kaydet
            </button>
          </div>
        </div>
      </div>


    </div>
  </div>
</div>

<h2 *ngIf="!error">{{ record }}</h2>
<h2 *ngIf="error">{{ error }}</h2>
<br />

<p></p>

<p></p>
<br />
<hr />
<button
  type="button"
  class="btn btn-warning"
  style="background-color: #d70040"
  (click)="findInventor()"
>
  {{
    visible
      ? "Kayıtlı Buluş Sahiplerini Gizle"
      : "Kayıtlı Buluş Sahiplerini Listele"
  }}
</button>

<h2 style="margin-left: 2%" *ngIf="visible && !error">
  Kayıtlı Buluş Sahipleri
</h2>
<h2 *ngIf="error">
  {{ error }} . Kayıt bilgilerini ve interneti kontrol ediniz.
</h2>
<input
  *ngIf="visible && !error"
  class="form-control"
  class="icon"
  type="text"
  name="search"
  [(ngModel)]="searchText"
  (ngModelChange)="searchText= $event.toLowerCase()"
  autocomplete="off"
  placeholder="Buluş Sahibi Bilgileri Üzerinden Arama Yap"
  id="input1"
/>

<table *ngIf="visible && !error">
  <thead>
    <th>#</th>
    <th>Buluş Sahibi Adı</th>
    <th>Buluş Sahibinin Adresi</th>
    <th>Buluş Sahibinin e-postası</th>
    <th>Buluş Sahibi Kimlik No</th>
    <th>Buluş Sahibinin Pozisyonu</th>
    <th>Buluş Sahibinin Çalıştığı Başvuru Sahibi</th>
    <th>Kaydı oluşturan ve kayıt tarihi</th>
  </thead>
  <tbody>
    <tr *ngFor="let user of users; let i = index">
      <ng-container *ngFor="let item of user | filter: searchText">
        <td>{{ i + 1 }}</td>
        <td>{{ item.inventorName }}</td>
        <td>{{ item.inventorAdress }}</td>
        <td>{{ item.inventorMail }}</td>
        <td>{{ item.inventorIdentityNo }}</td>
        <td>{{ item.inventorStatus }}</td>
        <td>{{ item.inventorsCompany | json }}</td>
        <td>
          Kaydı Yapan:{{ item.LoggedUser[0].recordingUser }}
          <p>Kayıt Tarihi:{{ item.LoggedUser[0].date | date: "dd/MM/yyyy" }}</p>
        </td>
        <td style="background-color: #f8f9fb">
          <button
            type="button"
            id="add"
            class="btn btn-primary"
            style="background-color: #d70040"
            (click)="removeInventor(i)"
          >
            Buluş Sahibi Sil
          </button>
        </td>
      </ng-container>
    </tr>
  </tbody>
</table>
